import EntitySelect from '@/components/app/EntitySelect';
import NoMenuLayout from '@/layouts/GlobalLayout/NoMenuLayout';
import { Row } from 'antd';
import React from 'react';
import {
  SellingIcon,
  ManagementIcon,
  GrowingIcon,
  TarrifIcon,
  StaffIcon,
  DiscountIcon,
  StationIcon,
  NotificationIcon,
  SettingIcon,
  SubscriptionIcon,
  FleetIcon,
  BusIcon,
  TemplateIcon,
  PassengerIcon,
  RouteAndTripIcon,
  TripCalendarIcon,
  TripDetailIcon,
  CounterIcon,
  TicketIcon,
  BookingIcon,
  TicketConflictIcon,
  RoleIcon,
  BusReportIcon,
  TvIcon,
  SaleReportIcon,
  ReconciliationIcon,
  ShipmentIcon,
} from '@/assets/icons/entities/_';
import { ROW_GUTTER } from '@/config';
import MainContent from '@/layouts/MainContent';
import i18n from '@/helpers/i18n';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { CompanyUrl } from '@/routers/companyRouters';

const sellingData = [
  { icon: <GrowingIcon />, name: i18n.t('menu.Dashboard'), url: CompanyUrl.Selling.Dashboard },
  { icon: <SaleReportIcon />, name: i18n.t('menu.Reports'), url: CompanyUrl.Selling.SalesReport },

  { icon: <BusReportIcon />, name: i18n.t('menu.TripStatusReport'), url: CompanyUrl.Selling.TripStatusReport },
  { icon: <TvIcon />, name: i18n.t('menu.TripStatusReport'), url: CompanyUrl.Selling.TripStatusTVScreen },

  { icon: <TarrifIcon />, name: i18n.t('menu.TicketTariffs'), url: CompanyUrl.Management.TicketTariffs },
  { icon: <TarrifIcon />, name: i18n.t('menu.BaggageTariffs'), url: CompanyUrl.Management.BaggageTariffs },
];

const ManagementData = [
  { icon: <BookingIcon />, name: i18n.t('menu.Bookings'), url: CompanyUrl.Management.Bookings },
  {
    icon: <BusIcon />,
    name: i18n.t('menu.SellOnTheGoBookings'),
    url: CompanyUrl.Management.SellOnTheGoBookings,
  },

  { icon: <TicketIcon />, name: i18n.t('menu.Tickets'), url: CompanyUrl.Management.Tickets },
  { icon: <TicketConflictIcon />, name: i18n.t('menu.TicketConflict'), url: CompanyUrl.Management.TicketConflict },

  { icon: <CounterIcon />, name: i18n.t('menu.Registers'), url: CompanyUrl.Management.Registers },
  { icon: <CounterIcon />, name: i18n.t('menu.Terminals'), url: CompanyUrl.Management.Terminals },
  { icon: <ReconciliationIcon />, name: i18n.t('menu.SellOnTheGoReconciliation'), url: CompanyUrl.Management.SellOnTheGoReconciliations },
  { icon: <ReconciliationIcon />, name: i18n.t('menu.BaggageReconciliations'), url: CompanyUrl.Management.BaggageReconciliations },

  { icon: <FleetIcon />, name: i18n.t('menu.Fleets'), url: CompanyUrl.Management.SeatModels },
  { icon: <BusIcon />, name: i18n.t('menu.Buses'), url: CompanyUrl.Management.Buses },
  { icon: <StationIcon />, name: i18n.t('menu.Stations'), url: CompanyUrl.Management.Stations },
  { icon: <TripCalendarIcon />, name: i18n.t('menu.TripsCalendar'), url: CompanyUrl.Management.TripsCalendar },
  { icon: <TripDetailIcon />, name: i18n.t('menu.TripDetails'), url: CompanyUrl.Management.TripDetails },

  { icon: <RouteAndTripIcon />, name: i18n.t('menu.RoutesAndTrips'), url: CompanyUrl.Management.Routes },

  { icon: <PassengerIcon />, name: i18n.t('menu.Passengers'), url: CompanyUrl.Management.Passengers },
  { icon: <ShipmentIcon />, name: i18n.t('menu.ShipmentManagement'), url: CompanyUrl.Management.ShipmentManagement },
  { icon: <NotificationIcon />, name: i18n.t('menu.Notifications'), url: CompanyUrl.Management.Notifications },
];
const GrowingData = [
  { icon: <StaffIcon />, name: i18n.t('menu.Staffs'), url: CompanyUrl.Growing.Staffs },
  { icon: <RoleIcon />, name: i18n.t('menu.Roles'), url: CompanyUrl.Growing.Roles },

  { icon: <DiscountIcon />, name: i18n.t('menu.Discounts'), url: CompanyUrl.Growing.Discounts },
  { icon: <SettingIcon />, name: i18n.t('menu.CompanySettings'), url: CompanyUrl.Growing.CompanySettings },
  { icon: <SubscriptionIcon />, name: i18n.t('menu.Subscriptions'), url: CompanyUrl.Growing.Subscriptions },
];

export default function SelectEntity() {
  const { t } = useTranslation();
  return (
    <NoMenuLayout>
      <Helmet title={t('selectEntityPage_Title')} />
      <MainContent noBackgroundColor>
        <Row gutter={ROW_GUTTER}>
          <EntitySelect
            icon={<SellingIcon />}
            title={t('selectEntityPage_Selling')}
            subTitle={t('selectEntityPage_Selling_Subtitle')}
            data={sellingData}
          />
          <EntitySelect
            icon={<ManagementIcon />}
            title={t('selectEntityPage_Management')}
            subTitle={t('selectEntityPage_Management_Subtitle')}
            data={ManagementData}
          />
          <EntitySelect
            icon={<GrowingIcon />}
            title={t('selectEntityPage_Growing')}
            subTitle={t('selectEntityPage_Growing_Subtitle')}
            data={GrowingData}
          />
        </Row>
      </MainContent>
    </NoMenuLayout>
  );
}
